<div
    class="cmps-cdk-cursor-pointer"
    [class.cmps-cdk-color-blue-100]="completed === true"
    [class.cmps-task-list-dialog--text-line-through]="completed === true"
    role="button"
    (click)="$event.stopPropagation(); click.emit()"
    *ngIf="editing !== true"
>
    <ng-content select="[cmpsTaskListTaskTitleLabel]"></ng-content>
</div>
<ng-container *ngIf="editing === true">
    <input
        type="text"
        class="cmps-form-input cmps-cdk-border-width-0p cmps-cdk-bg-color-transparent"
        [placeholder]="placeholder"
        [ngModel]="title"
        (ngModelChange)="nextTitle = $event"
        [attr.data-task]="msftTaskId"
        (click)="$event.preventDefault(); $event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation(); enter.emit()"
        #titleRef
    />
    <!-- mainly done to indicate the text changed from a div to an input -->
    <div
        class="cmps-task-list-task-title--input-line cmps-cdk-w-100pct cmps-cdk-pos-absolute cmps-cdk-pos-bottom-0dot25"
        [class.cmps-cdk-bg-color-grey-400]="
            titleRef !== _document.activeElement
        "
        [class.cmps-cdk-bg-color-blue-100]="
            titleRef === _document.activeElement
        "
    ></div>
</ng-container>
